<template>
  <section>
    <div class="card d-sm-block border-0 IntroductionIES3Wrapper">
      <div class=" d-flex">
        <div class="card-body">
          <div class="container-fluid">
            <div class="container text-center">
              <div class="row">
                <h2
                  class="productheadline wow fadeInDown col-12 hazardDetectedHeadline"
                >
                  {{ $t("hazard_detected") }}
                </h2>
              </div>
              <div class="row align-items-center">
                <h2
                  class="productheadlineh2 wow fadeInDown col-12 ies3SafeWorkingEnvHeadline"
                >
                  {{ $t("IES3_safe_working_env") }}
                </h2>
              </div>
            </div>
          </div>

          <div class="container-fluid  d-xs-block">
            <div class="row introductionIES3LowerHeadlineWrapper d-ml-inline">
              <div class="col-xs-12 col-sm-5 mb-3">
                <h2
                  class="statements wow fadeInLeft smokeEliminationAndUlpaHeadline"
                >
                  {{ $t("smoke_elimination_percentage") }}
                </h2>
                <p
                  class="fontp text-center wow fadeInLeft"
                  v-html="$t('evacuation_directly_above_source')"
                ></p>
              </div>
              <div class="col-xs-12 col-sm-5 offset-sm-2">
                <h2
                  class="statements wow fadeInRight smokeEliminationAndUlpaHeadline"
                >
                  {{ $t("ulpa_15_filter_percentage") }}
                </h2>
                <p
                  class="fontp text-center wow fadeInRight"
                  v-html="$t('micro_particals_elimination')"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "IntroductionIES3"
};
</script>

<style scoped>
.IntroductionIES3Wrapper {
  background-image: url("../../assets/images/background-ies3.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 56vw;
  border-radius: 0;
}
.smokeEliminationAndUlpaHeadline {
  color: black;
  letter-spacing: 2px;
}

.ies3SafeWorkingEnvHeadline {
  color: black;
  letter-spacing: 3px;
  margin-bottom: 50px;
}

.hazardDetectedHeadline {
  color: black;
}
@media (max-width: 767.98px) {
  .IntroductionIES3Wrapper {
    min-height: 90vw;
    background-position: center bottom;
  }
  .hazardDetectedHeadline {
    font-size: 1rem;
    line-height: 1.1rem;
    margin-bottom: 2rem;
  }
  .ies3SafeWorkingEnvHeadline {
    font-size: 1.2rem;
    line-height: 1.3rem;
    margin-bottom: 1rem;
  }
  .container {
    padding: 0;
  }
  h2 {
    padding: 0;
  }
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .hazardDetectedHeadline {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }
  .ies3SafeWorkingEnvHeadline {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
}
</style>
